/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './CardContentTile.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../themes/themes';

interface contentTileType {
  tile_key: string;
  tile_value: any;
  value_color?: string;
  key_color?: string;
  is_bold?: boolean;
  is_thirdTitle?: any;
  is_FourthTitle?: any;
  textWrap?: any;
}
const CardContentTile: React.FC<contentTileType> = ({
  tile_key,
  tile_value,
  value_color = themes.tileValue_black,
  key_color = themes.tileKey_grey,
  is_bold = false,
  is_thirdTitle,
  is_FourthTitle,
  textWrap
}) => {
  return (
    <Grid container className="tile-container">
      <Grid
        item
        xs={4}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: key_color,
          textTransform: 'capitalize',
          fontWeight: is_bold ? 'bolder' : 'normal',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          textWrap: textWrap
        }}
      >
        {tile_key}
      </Grid>
      <Grid
        item
        xs={8}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: value_color,
          wordBreak: 'break-word',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          textTransform: 'capitalize',
          fontWeight: is_bold ? 'bolder' : 'normal',
        }}
      >
        {tile_value}
      </Grid>
      {is_thirdTitle && (
        <Grid
          item
          xs={12}
          style={{
            marginTop: '0.5em',
            fontSize: fonts.smallSize,
            fontFamily: fonts.fontFamily,
            color: value_color,
            textAlign: 'left',
            textTransform: 'capitalize',
            fontWeight: is_bold ? 'bolder' : 'normal',
          }}
        >
          {is_thirdTitle}
        </Grid>
      )}
      {is_FourthTitle && (
        <Grid
          item
          xs={12}
          style={{
            marginTop: '0.2em',
            fontSize: fonts.smallSize,
            fontFamily: fonts.fontFamily,
            color: value_color,
            textAlign: 'left',
            textTransform: 'capitalize',
            fontWeight: is_bold ? 'bolder' : 'normal',
          }}
        >
          {is_FourthTitle}
        </Grid>
      )}
    </Grid>
  );
};

export default CardContentTile;
